<!--
 * @Autor: xiaona.wang
 * @Date: 2021-08-13 13:37:31
 * @LastEditTime: 2021-12-09 15:15:47
 * @LastEditors: xiaona.wang
 * @Description: 状态
-->
<template>
  <div v-if="text" :class="['repair-order-status', typeClass]">{{text}}</div>
</template>

<script>
export default {
  name: "RepsirOrderStatus",
  props: {
    text: String,
    type: String
  },
  computed: {
    typeClass() {
      return (this.type || "NORMAL").toLowerCase();
    }
  }
};
</script>

<style lang="scss" scoped>
  .repair-order-status{
    font-size: 14px;
    // line-height: 14px;
    color: #505363;

    &::before{
      display: inline-block;
      width: 6px;
      height: 6px;
      margin-right: 4px;
      vertical-align: middle;
      border-radius: 50%;
      content: "";
      transform: translateY(-2px);
    }

    &.normal{
      &::before{
        background: #00B259;
      }
    }
    &.islock{
      &::before{
      background: #E60000;
    }
    }
  }
</style>
